var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3282_355)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 150,
    height: 150,
    rx: 75,
    fill: "#FF5910"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 153,
    height: 153,
    rx: 76.5,
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.474 106.338H94.5483C92.6007 106.338 91.022 107.911 91.022 109.852C91.022 111.793 92.6007 113.367 94.5483 113.367H116.474C118.421 113.367 120 111.793 120 109.852C120 107.911 118.421 106.338 116.474 106.338Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.474 90.7227H100.425C98.478 90.7227 96.8992 92.2961 96.8992 94.237C96.8992 96.1779 98.478 97.7513 100.425 97.7513H116.474C118.421 97.7513 120 96.1779 120 94.237C120 92.2961 118.421 90.7227 116.474 90.7227Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 76.3516H106.926C104.979 76.3516 103.4 77.925 103.4 79.8659C103.4 81.8068 104.979 83.3802 106.926 83.3802H116.45C118.397 83.3802 119.976 81.8068 119.976 79.8659C119.976 77.925 118.397 76.3516 116.45 76.3516Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7937 113.366C64.2171 113.363 61.6865 112.684 59.4552 111.395C57.2238 110.107 55.3702 108.255 54.0798 106.025L41.9417 85.0112C40.6692 82.7784 40 80.2527 40 77.6828C40 75.1128 40.6692 72.5871 41.9417 70.3543L54.0798 49.3405C55.3702 47.1103 57.2238 45.2584 59.4552 43.9701C61.6865 42.6818 64.2171 42.0025 66.7937 42H91.07C93.6424 42.0067 96.1681 42.688 98.3949 43.9761C100.622 45.2642 102.472 47.1138 103.76 49.3405L113.355 65.7965C113.606 66.2293 113.761 66.7105 113.811 67.208C113.861 67.7055 113.805 68.2079 113.647 68.6821C113.488 69.1562 113.23 69.5912 112.89 69.958C112.55 70.3249 112.137 70.6154 111.676 70.8101C111.244 70.9969 110.779 71.0948 110.309 71.098C109.674 71.11 109.048 70.9517 108.495 70.6395C107.942 70.3273 107.483 69.8726 107.166 69.3228L97.5708 52.8428C96.8991 51.689 95.9363 50.7317 94.7786 50.0666C93.621 49.4015 92.3091 49.0518 90.974 49.0526H66.7937C65.4581 49.0494 64.1452 49.398 62.9872 50.0634C61.8291 50.7287 60.8667 51.6873 60.1968 52.8428L48.0587 73.8806C47.3866 75.035 47.0324 76.347 47.0324 77.6828C47.0324 79.0186 47.3866 80.3306 48.0587 81.4849L60.1968 102.523C60.8656 103.681 61.8271 104.643 62.9849 105.313C64.1427 105.982 65.4562 106.335 66.7937 106.337H81.5945C82.4764 106.41 83.2987 106.812 83.8981 107.463C84.4975 108.114 84.8302 108.966 84.8302 109.851C84.8302 110.736 84.4975 111.589 83.8981 112.24C83.2987 112.891 82.4764 113.293 81.5945 113.366H66.7937Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9153 91.7514C87.7053 91.7514 94.0205 85.4363 94.0205 77.6462C94.0205 69.8561 87.7053 63.541 79.9153 63.541C72.1252 63.541 65.8101 69.8561 65.8101 77.6462C65.8101 85.4363 72.1252 91.7514 79.9153 91.7514Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3282_355",
    x: -11,
    y: -11,
    width: 178,
    height: 178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3282_355"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3282_355",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.8e28de8e2e057fa6a5003133c670e0ce.svg";
export { ForwardRef as ReactComponent };